import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class AnnouncementsListController extends Controller {
  @service workplaceMetrics;

  /**
   * @type {boolean}
   */
  @tracked shouldShowNewAnnouncementModal = false;

  @action
  showNewAnnouncementModal() {
    this.workplaceMetrics.trackEvent('NEW_ANNOUNCEMENT_BUTTON_CLICKED', {
      location: 'announcements_lists_page',
    });
    this.shouldShowNewAnnouncementModal = true;
  }

  @action
  hideNewAnnouncementModal() {
    this.workplaceMetrics.trackEvent('NEW_ANNOUNCEMENT_MODAL_CLOSED', {
      location: 'announcements_lists_page',
    });
    this.shouldShowNewAnnouncementModal = false;
  }
}
